import DOMPurify from 'dompurify';

const FORBIDDEN_ATTRS = ['data-start', 'data-end'];

/**
 * Check if a string contains any HTML tags
 * @param {string} str
 * @returns {boolean}
 */
export function containsHtml(str) {
    if (!str || typeof str !== 'string') return false;
    return /<[a-z][\s\S]*>/i.test(str);
}

/**
 * Sanitize HTML string — remove dangerous tags/attributes, ensure links are safe.
 * Uses the browser's DOMParser for robust parsing.
 *
 * @param {string} html - Raw HTML string
 * @returns {string} Sanitized HTML safe for dangerouslySetInnerHTML
 */
export function sanitizeHtml(html) {
    if (!html || typeof html !== 'string') return '';

    return DOMPurify.sanitize(html, {
        FORBID_ATTR: FORBIDDEN_ATTRS,
    });
}
